import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
// import MenuItem from '@material-ui/core/MenuItem';
import DateFnsUtils from '@date-io/date-fns';
import { ja } from 'date-fns/locale';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getGroupDetail } from '../../actions/Groups';
import { getGochiTipSummary } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import {
  getDepositCurrentMonthGroup,
  getDepositByMonthGroup,
  getDepositDetailCurrentMonthGroup,
  getDepositDetailByMonthGroup,
  downloadDepositDetailCurrentMonth,
  downloadDepositDetailByMonth,
  sendMailDepositDetailMonth
} from '../../actions/Deposits';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import EmailChangeGroup from '../organisms/EmailChangeGroup';
import PasswordChangeGroup from '../organisms/PasswordChangeGroup';
import GroupPaymentInfoGroup from '../organisms/GroupPaymentInfoGroup';
import 'moment/locale/ja';
import {
  downloadPdfInvoice,
  DOWNLOAD_PDF_INVOICE_SUCCESS
} from '../../actions/Invoices';

moment.locale('ja');

const Accordion = withStyles({
  root: {
    border: 0,
    boxShadow: 'none',
    '&::before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    border: 0,
    marginBottom: -1,
    padding: '0 10px',
    '&$expanded': {
      minHeight: 48
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: 0
  }
})(MuiAccordionDetails);

const styles = theme => ({
  root: {
    // backgroundColor: '#e0e0e0',
    // flexGrow: 1,
    // width: '100%'
    display: 'flex',
    minWidth: 1400
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)'
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  pageTitileDiv: {
    paddingBottom: 10
  },
  pageTitle: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  rowBox: {
    display: 'flex',
    marginLeft: '-20px',
    marginRight: '-20px'
  },
  rowColTwo: {
    width: '50%',
    paddingLeft: 20,
    paddingRight: 20
  },
  rowColTwoRight: {
    borderLeft: '1px solid #D1D1D1'
  },
  mainPaperLeft: {
    backgroundColor: '#2196F3',
    borderRadius: '8px',
    color: '#fff'
  },
  mainPaperRight: {
    borderRadius: '8px',
    color: '#fff'
  },
  wrapper: {
    padding: 20
  },
  alignRight: {
    marginLeft: 'auto'
  },
  divCenter: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    marginBottom: 20
  },
  divRight: {
    textAlign: 'right'
  },
  textBold: {
    fontWeight: 'bold'
  },
  textWhite: {
    color: '#fff !important'
  },
  fs10: {
    fontSize: '10px !important'
  },
  fs12: {
    fontSize: '12px !important'
  },
  fs16: {
    fontSize: '16px !important'
  },
  fs20: {
    fontSize: '20px !important'
  },
  buttonsWrapper: {
    padding: '20px 0'
  },
  amountDiv: {
    display: 'flex',
    paddingTop: 5
  },
  bigAmountNumber: {
    fontSize: 50,
    fontWeight: 'bold'
  },
  currencyUnit: {
    fontWeight: 'bold',
    fontSize: 30,
    paddingLeft: 10,
    paddingTop: 30
  },
  smallPaper: {
    padding: 15
  },
  smallAmountNumber: {
    fontSize: 30,
    fontWeight: 'bold',
    color: '#000'
  },
  currencyUnitSmall: {
    fontWeight: 'bold',
    fontSize: 15,
    padding: '15px 0 10px 5px',
    color: '#000'
  },
  button: {
    fontSize: 14,
    fontWeight: 'bold',
    padding: '10px 0',
    margin: '0 auto',
    width: '30.3%'
  },
  listShopsDiv: {
    marginTop: 35
  },
  noteDiv: {
    fontSize: 12,
    lineHeight: '18px'
  },
  flexDivMonth: {
    display: 'flex',
    alignItems: 'flex-end'
  },
  btnSendMail: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10
  },
  formControl: {
    width: 140,
    marginLeft: 10,
    textAlign: 'center'
  },
  textRight: {
    textAlign: 'right'
  },
  horizotalLine: {
    borderBottom: '1px solid #DBDBDB'
  },
  textHeading: {
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '16px',
    marginLeft: 5,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  collapseBtn: {
    backgroundColor: 'transparent',
    flexDirection: 'row-reverse',
    padding: 0,
    marginLeft: '-12px',
    borderBottom: 'none'
  },
  arrowCustom: {
    backgroundColor: '#2196F3',
    color: '#ffffff',
    width: 13,
    height: 13,
    borderRadius: '50%',
    margin: 0
  },
  tableInfo: {
    width: '100%',
    marginBottom: 10
  },
  tableInfoRow: {
    border: '1px solid #ddd'
  },
  tableInfoCellHeader: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '12px',
    padding: '2px 10px',
    // width: '180px',
    // maxWidth: '150px',
    border: '1px transparent #ddd',
    color: '#000000',
    backgroundColor: '#F7F7F7',
    whiteSpace: 'nowrap'
  },
  tableInfoCellHeaderVertical: {
    width: '50%',
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '12px',
    padding: '2px 10px',
    border: '1px solid #ddd',
    color: '#000000',
    backgroundColor: '#F7F7F7',
    whiteSpace: 'nowrap'
  },
  tableInfoCell: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '12px',
    padding: '2px 10px',
    // borderBottom: '2px solid transparent',
    border: '1px transparent #ddd',
    whiteSpace: 'break-spaces'
  },
  scrollX: {
    overflowX: 'auto'
  },
  viewStripeLinkDiv: {
    fontSize: 12,
    marginTop: 10
  },
  donateGochiKidBox: {
    fontWeight: 700,
    border: '4px solid #2196F3',
    borderRadius: 2,
    color: '#2196F3',
    marginTop: 24,
    padding: '24px 16px'
  },
  donateGochiKidAmount: {
    display: 'flex',
    margin: '5px 0 15px'
  },
  donateGochiKidIcon: {
    width: 9,
    height: 10,
    marginLeft: 5
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      // shops: state.shops.shops,
      // totalCount: state.shops.totalCount,
      // limit: state.shops.limit,
      groupDetail: state.groups.detail
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroupDetail,
          getAccounts,
          getDepositCurrentMonthGroup,
          getDepositByMonthGroup,
          getDepositDetailCurrentMonthGroup,
          getDepositDetailByMonthGroup,
          downloadDepositDetailCurrentMonth,
          downloadDepositDetailByMonth,
          sendMailDepositDetailMonth,
          getGochiTipSummary,
          downloadPdfInvoice
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('shopId', 'setShopId', null),
  withState('shopName', 'setShopName', null),
  withState('shopId2', 'setShopId2', null),
  withState('shopName2', 'setShopName2', null),
  withState('shops', 'setShops', []),
  withState('totalCount', 'setTotalCount', 0),
  withState('limit', 'setLimit', 0),
  withState('shops2', 'setShops2', []),
  withState('totalCount2', 'setTotalCount2', 0),
  withState('limit2', 'setLimit2', 10),
  withState('page', 'setPage', 1),
  withState('page2', 'setPage2', 1),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('filterParams', 'setFilterParams', {}),
  withState('hideRowsPerPage', 'setHideRowsPerPage', true),
  withState('openTable', 'updateOpenTable', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('currentMonthYear', 'setCurrentMonthYear', null),
  withState('month', 'setMonth', () => {
    const tmp = { monthValue: null, monthYearValue: null };
    const today = new Date();
    const milestone = new Date();
    milestone.setMonth(today.getMonth() - 1);
    console.log('milestone', milestone);
    const tmpMonth = milestone.getMonth() + 1;
    tmp.monthValue = tmpMonth;
    tmp.monthYearValue = `${milestone.getFullYear()}${tmpMonth}`;
    return tmp;
    // return `${milestone.getFullYear()}${tmpMonth}`;
  }),
  withState('depositCurrentMonth', 'setDepositCurrentMonth', null),
  withState('depositByMonth', 'setDepositByMonth', null),
  withState('openGroupChangeMail', 'updateOpenGroupChangeMail', false),
  withState('openGroupChangePassword', 'updateOpenGroupChangePassword', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('listMonths', 'setListMonths', () => {
    const tmp = [{ value: '202011', label: '2020/11' }];
    const today = new Date();
    const milestone = new Date('Nov 01, 2020');
    while (
      !(
        milestone.getFullYear() === today.getFullYear() &&
        milestone.getMonth() === today.getMonth()
      )
    ) {
      milestone.setMonth(milestone.getMonth() + 1);
      const tmpDate = new Date(milestone);
      let tmpMonth = tmpDate.getMonth() + 1;
      if (tmpMonth < 10) {
        tmpMonth = `0${tmpMonth}`;
      }
      tmp.push({
        value: `${milestone.getFullYear()}${tmpMonth}`,
        label: `${milestone.getFullYear()}/${tmpMonth}`
      });
    }
    return tmp;
  }),
  withState('defaultMonth', 'setDefaultMonth', () => {
    const newDate = new Date();
    return newDate.setMonth(newDate.getMonth() - 1);
  }),
  withState('currentMonth', 'setCurrentMonth', () => {
    let tmp = '';
    const today = new Date();
    let tmpMonth = today.getMonth() + 1;
    if (tmpMonth < 10) {
      tmpMonth = `0${tmpMonth}`;
    }
    let tmpDay = today.getDate();
    if (tmpDay === 1) {
      tmpDay = today.getDate() + 1;
    }
    if (tmpDay < 10) {
      tmpDay = `0${tmpDay}`;
    }
    tmp = `${today.getFullYear()}-${tmpMonth}-${tmpDay}`;
    return tmp;
  }),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },

    handleGetDepositCurrentMonth: props => async () => {
      props.updateLoading(true);
      props.updateOpenProgress(true);
      return props.actions
        .getDepositCurrentMonthGroup()
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === 'GET_DEPOSIT_CURRENT_MONTH_GROUP_SUCCESS') {
            console.log('data handleGetDepositCurrentMonth ======', data);
            props.setDepositCurrentMonth(data.payload);
            const currentMonthStr = data.payload.currentMonthYearStr;
            props.setCurrentMonthYear(data.payload.currentMonthYearStr);
            const year = Number(currentMonthStr.slice(0, 4));
            const month = Number(currentMonthStr.slice(-2)) - 1;
            const date = new Date();
            date.setFullYear(year);
            date.setMonth(month);
            return date;
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          return null;
        })
        .catch(e => {
          console.log(e);
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    },

    handleGetDepositByMonth: props => async monthValue => {
      props.updateLoading(true);
      props.updateOpenProgress(true);
      await props.actions
        .getDepositByMonthGroup(monthValue)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === 'GET_DEPOSIT_BY_MONTH_GROUP_SUCCESS') {
            console.log('data handleGetDepositByMonth ======', data);
            props.setDepositByMonth(data.payload);
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        })
        .catch(e => {
          console.log(e);
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    },

    handleGetDepositDetailCurrentMonth: props => async (
      event,
      page,
      limit,
      filterParams
    ) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 10;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        // groupId: props.groupId,
        unnarrowDownGroup: props.unnarrowDownGroup,
        page,
        limit: limit || limitNum,
        ...filterParams
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      await props.actions
        .getDepositDetailCurrentMonthGroup(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.setShops(data.payload.list);
          props.setTotalCount(data.payload.count);
          props.setLimit(data.payload.limit);
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    },

    handleGetDepositDetailByMonth: props => async (
      event,
      page,
      limit,
      filterParams,
      monthValue
    ) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage2(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 10;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      let monthTmp = monthValue;
      if (!monthTmp) {
        monthTmp = props.month.monthYearValue;
      }

      const searchKey = {
        // groupId: props.groupId,
        // unnarrowDownGroup: props.unnarrowDownGroup,
        page,
        limit: limit || limitNum,
        ...filterParams
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      await props.actions
        .getDepositDetailByMonthGroup(monthTmp, searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.setShops2(data.payload.list);
          props.setTotalCount2(data.payload.count);
          props.setLimit2(data.payload.limit);
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    }
  }),
  withHandlers({
    handleChangeMonth: props => e => {
      console.log('1234556', e);
      if (e !== '') {
        props.setDefaultMonth(e);
        const my = new Date(e);
        let tmpMonth = '';
        if (my.getMonth() + 1 < 10) {
          tmpMonth = `0${my.getMonth() + 1}`;
        } else {
          tmpMonth = my.getMonth() + 1;
        }
        props.setMonth({
          monthValue: my.getMonth() + 1,
          monthYearValue: `${my.getFullYear()}${tmpMonth}`
        });
        props.handleGetDepositByMonth(`${my.getFullYear()}${tmpMonth}`);
        const newFilterParams = {
          shopId: undefined,
          shopName: undefined
        };
        props.handleGetDepositDetailByMonth(
          null,
          1,
          props.limit2,
          newFilterParams,
          `${my.getFullYear()}${tmpMonth}`
        );
        props.setShopId2('');
        props.setShopName2('');
      }
    }
  }),
  lifecycle({
    async componentDidMount() {
      isAuthenticated(this.props);
      const currentMonth = await this.props.handleGetDepositCurrentMonth();
      if (this.props.account.fukuokaFlag === 1) {
        const date = new Date();
        let previousM = new Date(date.getTime());
        previousM.setDate(0);
        if (currentMonth) {
          previousM = new Date(new Date(currentMonth).getTime());
          previousM.setDate(0);
        }
        this.props.handleChangeMonth(previousM);
      } else {
        this.props.handleChangeMonth(currentMonth);
      }
      this.props.handleGetDepositDetailCurrentMonth(null, 1, this.props.limit, {
        shopId: this.props.shopId,
        shopName: this.props.shopName
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    month, // listMonths,
    loading,
    openProgress,
    depositCurrentMonth,
    depositByMonth,
    openGroupChangeMail,
    updateOpenGroupChangeMail,
    openGroupChangePassword,
    updateOpenGroupChangePassword,
    shops,
    shops2,
    openTable,
    totalCount,
    totalCount2,
    limit,
    page,
    limit2,
    page2,
    handleGetDepositDetailCurrentMonth,
    handleGetDepositDetailByMonth,
    shopId,
    setShopId,
    shopName,
    setShopName,
    shopId2,
    setShopId2,
    shopName2,
    setShopName2,
    updateLoading,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    currentMonthYear,
    defaultMonth,
    handleChangeMonth,
    account,
    handleRedirect
  }) => {
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;

    const handleSendMail = async params => {
      console.log('handle send mail');
      updateLoading(true);
      updateOpenProgress(true);
      const result = await actions
        .sendMailDepositDetailMonth(params)
        .then(data => checkSession(data));
      if (result.type === 'SEND_MAIL_DEPOSIT_DETAIL_MONTH_SUCCESS') {
        setResultMessage('入金詳細のメールを送りました。');
        updateLoading(false);
        updateOpenProgress(false);
      } else {
        setResultMessage(
          '入金詳細のメールが送れません。もう一度お試しください。'
        );
        updateLoading(false);
        updateOpenProgress(false);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const dateFormat = timeStr => {
      if (!timeStr) {
        return null;
      }
      const date = new Date(timeStr);
      let day = date.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      let monthCurr = date.getMonth() + 1;
      if (monthCurr < 10) {
        monthCurr = `0${monthCurr}`;
      }
      const year = date.getFullYear();
      return `${year}/${monthCurr}/${day}`;
    };

    const currencyFormat = num => {
      if (!num) {
        return 0;
      }
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    const downloadCsvBlob = (blob, fileName) => {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv' }));
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();
        linkEl.parentNode.removeChild(linkEl);
        // iOSのクリックイベント対策
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const handleDownloadDepositDetailCurrentMonth = async (
      event,
      pageValue,
      limitValue,
      filterParams
    ) => {
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 10;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const searchKey = {
        page: pageValue,
        limit: limitValue || limitNum,
        ...filterParams
      };
      updateLoading(true);
      updateOpenProgress(true);
      await actions
        .downloadDepositDetailCurrentMonth(searchKey)
        .then(data => {
          checkSession(data);
          if (
            data.type === 'DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_SUCCESS'
          ) {
            const timeStamp = moment()
              .tz('Asia/Tokyo')
              .format('YYYYMMDDHHmm');
            let csvCurrentMonth = `${timeStamp}_deposit_detail_current_month.csv`;
            if (typeof account !== 'undefined' && account.fukuokaFlag === 1) {
              csvCurrentMonth = `${timeStamp}_calculate_detail_current_month.csv`;
            }
            downloadCsvBlob(data.payload, csvCurrentMonth);
          }
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
        })
        .catch(e => {
          console.log(e);
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
        });
    };

    const handleDownloadDepositDetailByMonth = async (
      event,
      pageValue,
      limitValue,
      filterParams,
      monthValue
    ) => {
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 10;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const searchKey = {
        page: pageValue,
        limit: limitValue || limitNum,
        ...filterParams
      };
      updateLoading(true);
      updateOpenProgress(true);
      await actions
        .downloadDepositDetailByMonth(monthValue, searchKey)
        .then(data => {
          // if (data.error === true && data.payload.status === 403) {
          //   sendLogin(props);
          // }
          if (data.type === 'DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_SUCCESS') {
            const timeStamp = moment()
              .tz('Asia/Tokyo')
              .format('YYYYMMDDHHmm');
            let csvByMonth = `${timeStamp}_deposit_detail_by_month.csv`;
            if (typeof account !== 'undefined' && account.fukuokaFlag === 1) {
              csvByMonth = `${timeStamp}_calculate_detail_by_month.csv`;
            }
            downloadCsvBlob(data.payload, csvByMonth);
          }
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
        })
        .catch(e => {
          console.log(e);
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
        });
    };

    const downloadPdfBlob = (blob, fileName) => {
      const blobC = new Blob([blob], {
        type: 'application/pdf'
      });
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blobC, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(blobC);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const handleDownloadPdfInvoice = async (monthInput, fileName) => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .downloadPdfInvoice(monthInput)
        .then(data => checkSession(data));
      if (response.type === DOWNLOAD_PDF_INVOICE_SUCCESS) {
        downloadPdfBlob(response.payload, fileName);
      }
      updateLoading(false);
      updateOpenProgress(false);
    };

    const goToDonateGochiKid = () => {
      handleRedirect('/donations_group');
    };

    const { groupDisplayLimit } = account;
    const dd = new Date();
    const lastDayOfMonth = new Date(dd.getFullYear(), dd.getMonth() + 1, 0);

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="入金情報管理" />
        <main className={classes.content}>
          <Typography variant="h6" noWrap className={classes.title}>
            {isFukuoka ? '精算情報管理' : '入金情報管理'}
          </Typography>
          <div className={classes.pageTitileDiv}>
            <Typography color="textPrimary" className={classes.pageTitle}>
              グループ全体
            </Typography>
          </div>
          <div className={classes.rowBox}>
            <div className={classes.rowColTwo}>
              <Paper className={classes.mainPaperLeft} elevation={1}>
                <div className={classes.wrapper}>
                  <div className={classes.divCenter}>
                    <div>
                      <Typography
                        color="textPrimary"
                        className={`${classes.fs20} ${classes.textBold} ${
                          classes.textWhite
                        }`}
                      >
                        {depositCurrentMonth &&
                        depositCurrentMonth.currentMonthStr
                          ? depositCurrentMonth.currentMonthStr
                          : '-'}
                        {isFukuoka ? '月の精算金額(※1)' : '月の入金金額'}
                      </Typography>
                      <div className={classes.amountDiv}>
                        <div className={classes.bigAmountNumber}>
                          {depositCurrentMonth &&
                          depositCurrentMonth.depositAmountCurrentMonth
                            ? currencyFormat(
                                depositCurrentMonth.depositAmountCurrentMonth
                              )
                            : 0}
                        </div>
                        <div className={classes.currencyUnit}>円</div>
                      </div>
                    </div>
                    <div className={classes.alignRight}>
                      <Paper className={classes.smallPaper} elevation={1}>
                        <div>
                          <Typography
                            color="textPrimary"
                            className={`${classes.fs16} ${classes.textBold} ${
                              classes.textBlack
                            }`}
                          >
                            {isFukuoka
                              ? `現時点での${
                                  depositCurrentMonth &&
                                  depositCurrentMonth.nextMonthStr
                                    ? depositCurrentMonth.nextMonthStr
                                    : '-'
                                }月精算予定金額(※2)`
                              : '現在のお支払い残額'}
                          </Typography>
                          <div className={classes.amountDiv}>
                            <div className={classes.smallAmountNumber}>
                              {// eslint-disable-next-line no-nested-ternary
                              isFukuoka
                                ? depositCurrentMonth &&
                                  depositCurrentMonth.depositAmountNextMonth
                                  ? currencyFormat(
                                      depositCurrentMonth.depositAmountNextMonth
                                    )
                                  : 0
                                : depositCurrentMonth &&
                                  depositCurrentMonth.paymentBalance
                                ? depositCurrentMonth.paymentBalance.toLocaleString()
                                : 0}
                            </div>
                            <div className={classes.currencyUnitSmall}>円</div>
                          </div>
                        </div>
                      </Paper>
                    </div>
                  </div>
                  <div className={classes.divCenter}>
                    <Typography className={classes.fs12}>
                      {isFukuoka && (
                        <>
                          ※1
                          毎月9営業日までは前月末の振込金額を表示します。10営業日からは今月末の振込予定金額を表示します。
                          <br />
                          ※2
                          毎月9営業日までは今月末の振込予定金額を表示します。10営業日からは翌月末の振込予定金額を表示します。
                        </>
                      )}
                    </Typography>
                  </div>
                  <div className={`${classes.divRight} ${classes.fs12}`}>
                    {dateFormat(new Date())}
                    {` `}
                    現在
                  </div>
                </div>
              </Paper>

              {!isFukuoka && (
                <div className={classes.donateGochiKidBox}>
                  <div style={{ fontSize: 18 }}>こどもごちめし支援額</div>
                  <div className={classes.donateGochiKidAmount}>
                    <div>
                      <span style={{ fontSize: 16 }}>支援残額</span>
                      <span style={{ fontSize: 20, marginLeft: 8 }}>
                        {depositCurrentMonth &&
                        depositCurrentMonth.sumAmountGochiKidCanUse
                          ? depositCurrentMonth.sumAmountGochiKidCanUse.toLocaleString()
                          : 0}
                      </span>
                      <span style={{ fontSize: 12 }}>円</span>
                    </div>
                    <div style={{ marginLeft: 80 }}>
                      <span style={{ fontSize: 16 }}>支援額累計</span>
                      <span style={{ fontSize: 20, marginLeft: 8 }}>
                        {depositCurrentMonth &&
                        depositCurrentMonth.sumAmountGochiKidDonate
                          ? depositCurrentMonth.sumAmountGochiKidDonate.toLocaleString()
                          : 0}
                      </span>
                      <span style={{ fontSize: 12 }}>円</span>
                    </div>
                  </div>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => goToDonateGochiKid()}
                    >
                      <span>詳細</span>
                      <ArrowForwardIosIcon
                        className={classes.donateGochiKidIcon}
                      />
                    </Button>
                  </div>
                </div>
              )}
            </div>
            <div className={`${classes.rowColTwo} ${classes.rowColTwoRight}`}>
              <Paper className={classes.mainPaperRight} elevation={1}>
                <div className={classes.wrapper}>
                  <div className={classes.divCenter}>
                    <div className={classes.flexDivMonth}>
                      <Typography
                        color="textPrimary"
                        className={`${classes.fs20} ${classes.textBold}`}
                      >
                        {isFukuoka ? (
                          <>過去の精算金額検索</>
                        ) : (
                          <>
                            {month.monthValue ? month.monthValue : '-'}
                            月の入金金額
                          </>
                        )}
                      </Typography>
                      <FormControl
                        className={`${classes.alignRight} ${
                          classes.formControl
                        }`}
                      >
                        {/* <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={month.monthYearValue}
                          onChange={handleChangeMonth}
                        >
                          {listMonths.map(item => {
                            return (
                              <MenuItem key={item.value} value={item.value}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                        </Select> */}
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={ja}
                          libInstance={moment}
                        >
                          <Grid container justify="space-around">
                            <DatePicker
                              variant="inline"
                              openTo="year"
                              format="y年M月"
                              views={['year', 'month']}
                              // label="Year and Month"
                              // helperText="Start from year selection"
                              maxDate={lastDayOfMonth}
                              value={defaultMonth}
                              onChange={handleChangeMonth}
                            />
                          </Grid>
                        </MuiPickersUtilsProvider>
                      </FormControl>
                    </div>
                    <div className={classes.alignRight}>
                      <div className={classes.textRight}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.btnSendMail}
                          onClick={() => handleSendMail(month.monthYearValue)}
                        >
                          {isFukuoka ? '精算明細を送る' : '入金明細を送る'}
                        </Button>
                        <Typography
                          color="textPrimary"
                          className={classes.fs10}
                        >
                          {isFukuoka
                            ? '※登録メールアドレス宛に送ります'
                            : '※入金明細を登録メールアドレス宛に送ります'}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  {isFukuoka && (
                    <div className={classes.flexDivMonth}>
                      <Typography color="textPrimary">
                        選択した振込月の精算金額を表示します。
                      </Typography>
                    </div>
                  )}
                  <div className={classes.amountDiv}>
                    <div className={classes.smallAmountNumber}>
                      {depositByMonth && depositByMonth.amountDeposit
                        ? currencyFormat(depositByMonth.amountDeposit)
                        : 0}
                    </div>
                    <div className={classes.currencyUnitSmall}>円*</div>
                  </div>
                  <div className={classes.horizotalLine} />
                  {!isFukuoka && (
                    <Accordion defaultExpanded>
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon className={classes.arrowCustom} />
                        }
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                        className={classes.collapseBtn}
                      >
                        <Typography className={classes.textHeading}>
                          Stripe入金分
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Table className={classes.tableInfo}>
                          <TableBody>
                            <TableRow className={classes.tableInfoRow}>
                              <TableCell
                                className={classes.tableInfoCellHeader}
                              >
                                今月売上額
                              </TableCell>
                            </TableRow>
                            <TableRow className={classes.tableInfoRow}>
                              <TableCell className={classes.tableInfoCell}>
                                {depositByMonth &&
                                depositByMonth.stripeAmountDeposit
                                  ? currencyFormat(
                                      depositByMonth.stripeAmountDeposit
                                    )
                                  : 0}
                                {` 円`}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </AccordionDetails>
                    </Accordion>
                  )}
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon className={classes.arrowCustom} />
                      }
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                      className={classes.collapseBtn}
                    >
                      <Typography className={classes.textHeading}>
                        {isFukuoka ? '精算明細' : '銀行口座入金分'}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.scrollX}>
                      <Table className={classes.tableInfo}>
                        <TableBody>
                          <TableRow className={classes.tableInfoRow}>
                            {depositByMonth &&
                              depositByMonth.groupPaymentSummaries &&
                              depositByMonth.groupPaymentSummaries.length > 0 &&
                              depositByMonth.groupPaymentSummaries.map(item => {
                                return (
                                  <TableCell
                                    className={classes.tableInfoCellHeader}
                                  >
                                    {item.rowLabel}
                                  </TableCell>
                                );
                              })}
                            {!isFukuoka && (
                              <TableCell
                                className={classes.tableInfoCellHeader}
                              >
                                銀行振込分総計
                              </TableCell>
                            )}
                          </TableRow>
                          <TableRow className={classes.tableInfoRow}>
                            {depositByMonth &&
                              depositByMonth.groupPaymentSummaries &&
                              depositByMonth.groupPaymentSummaries.length > 0 &&
                              depositByMonth.groupPaymentSummaries.map(item => {
                                return (
                                  <TableCell className={classes.tableInfoCell}>
                                    {currencyFormat(item.amount)}
                                    {` 円`}
                                  </TableCell>
                                );
                              })}
                            {!isFukuoka && (
                              <TableCell className={classes.tableInfoCell}>
                                {depositByMonth &&
                                depositByMonth.bankAmountDeposit
                                  ? currencyFormat(
                                      depositByMonth.bankAmountDeposit
                                    )
                                  : 0}
                                {` 円`}
                              </TableCell>
                            )}
                          </TableRow>
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                    {!isFukuoka && (
                      <div className={classes.viewStripeLinkDiv}>
                        *銀行振込には所定の振込手数料がかかります。
                        <Link
                          href="https://support.gochimeshi.com/s/article/sales-payout-bank-fee-shop/"
                          target="_blank"
                        >
                          詳しくはこちら。
                        </Link>
                      </div>
                    )}
                  </Accordion>
                  {groupDisplayLimit !== 1 && !isFukuoka && (
                    <Accordion defaultExpanded>
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon className={classes.arrowCustom} />
                        }
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                        className={classes.collapseBtn}
                      >
                        <Typography className={classes.textHeading}>
                          ごちっぷ入金分
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.scrollX}>
                        <Table className={classes.tableInfo}>
                          <TableBody>
                            <TableRow className={classes.tableInfoRow}>
                              <TableCell
                                className={classes.tableInfoCellHeaderVertical}
                              >
                                {depositByMonth &&
                                depositByMonth.gochiTip &&
                                depositByMonth.gochiTip.month
                                  ? moment(
                                      `${depositByMonth.gochiTip.month}`
                                    ).format('M')
                                  : ''}
                                月ごちっぷ金額
                              </TableCell>
                              <TableCell className={classes.tableInfoCell}>
                                {depositByMonth &&
                                depositByMonth.gochiTip &&
                                depositByMonth.gochiTip.totalAmount
                                  ? currencyFormat(
                                      depositByMonth.gochiTip.totalAmount
                                    )
                                  : 0}
                                円
                              </TableCell>
                            </TableRow>
                            <TableRow className={classes.tableInfoRow}>
                              <TableCell
                                className={classes.tableInfoCellHeaderVertical}
                              >
                                {depositByMonth &&
                                depositByMonth.gochiTip &&
                                depositByMonth.gochiTip.month
                                  ? moment(
                                      `${depositByMonth.gochiTip.month}`
                                    ).format('M')
                                  : ''}
                                月ごちっぷ数
                              </TableCell>
                              <TableCell className={classes.tableInfoCell}>
                                {depositByMonth &&
                                depositByMonth.gochiTip &&
                                depositByMonth.gochiTip.totalCount
                                  ? depositByMonth.gochiTip.totalCount
                                  : 0}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </AccordionDetails>
                    </Accordion>
                  )}
                  {!isFukuoka &&
                    depositByMonth &&
                    depositByMonth.transferDate &&
                    depositByMonth.groupPaymentSummaries &&
                    depositByMonth.groupPaymentSummaries.length > 0 &&
                    depositByMonth.groupPaymentSummaries.find(
                      element => element.rowLabel === '銀行振込手数料'
                    ) && (
                      <div className={classes.divCenter}>
                        <div className={classes.alignRight}>
                          <div className={classes.textRight}>
                            <Button
                              variant="outlined"
                              color="primary"
                              className={classes.btnSendMail}
                              style={{ margin: '4px 0 14px' }}
                              onClick={() =>
                                handleDownloadPdfInvoice(
                                  month.monthYearValue,
                                  `invoice fee ${account.groupId}${moment(
                                    `${month.monthYearValue}01`,
                                    'YYYYMMDD'
                                  ).format('YYMM')}-1.pdf`
                                )
                              }
                            >
                              請求書ダウンロード
                            </Button>
                            <Typography
                              color="textPrimary"
                              className={classes.fs10}
                            >
                              ※銀行振込手数料分の請求書を発行しております。
                            </Typography>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </Paper>
            </div>
          </div>

          <div className={classes.rowBox}>
            <div className={`${classes.rowColTwo}`}>
              <div className={`${classes.listShopsDiv}`}>
                <GroupPaymentInfoGroup
                  month={
                    depositCurrentMonth && depositCurrentMonth.currentMonthStr
                      ? depositCurrentMonth.currentMonthStr
                      : '-'
                  }
                  currencyFormat={currencyFormat}
                  shops={shops}
                  openTable={openTable}
                  totalCount={totalCount}
                  limit={limit}
                  page={page}
                  handleChangePage={handleGetDepositDetailCurrentMonth}
                  shopId={shopId}
                  setShopId={setShopId}
                  shopName={shopName}
                  setShopName={setShopName}
                  downloadCsvAction={handleDownloadDepositDetailCurrentMonth}
                  currentMonthYear={currentMonthYear}
                  isFukuoka={isFukuoka}
                />
              </div>
            </div>

            <div className={`${classes.rowColTwo} ${classes.rowColTwoRight}`}>
              <div className={`${classes.listShopsDiv}`}>
                <GroupPaymentInfoGroup
                  month={month.monthValue}
                  monthYear={month.monthYearValue}
                  currencyFormat={currencyFormat}
                  shops={shops2}
                  openTable={openTable}
                  totalCount={totalCount2}
                  limit={limit2}
                  page={page2}
                  handleChangePage={handleGetDepositDetailByMonth}
                  shopId={shopId2}
                  setShopId={setShopId2}
                  shopName={shopName2}
                  setShopName={setShopName2}
                  downloadCsvAction={handleDownloadDepositDetailByMonth}
                  currentMonthYear={month.monthYearValue}
                  isFukuoka={isFukuoka}
                  isTable2
                />
              </div>
            </div>
          </div>
          <div className={classes.noteDiv}>
            {!isFukuoka && (
              <>
                ※1「入金金額」では直近の銀行振込による入金額を反映しています。入金額の詳細は？から確認できます。
                <br />
                ※2「入金予定金額」では、口座振込を設定されている場合は、当月の現在までのチケット売上を反映しています。Stripeでの入金を設定されている場合は、当月の現在までのStripe入金額を反映しています。
                <br />
                <br />
              </>
            )}
            <Link
              href="https://support.gochimeshi.com/s/article/group-payment-information-management-shop/"
              target="_blank"
            >
              詳しい説明はこちら
            </Link>
          </div>

          <div>
            <Modal open={openGroupChangeMail} className={classes.mainModal}>
              <EmailChangeGroup
                updateOpenGroupChangeMail={updateOpenGroupChangeMail}
              />
            </Modal>
            <Modal open={openGroupChangePassword} className={classes.mainModal}>
              <PasswordChangeGroup
                updateOpenGroupChangePassword={updateOpenGroupChangePassword}
              />
            </Modal>
          </div>
        </main>

        <ProgressDialog
          openProgress={openProgress}
          loading={loading}
          progressOkAction={progressOkAction}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
